<template>
  <v-row>
    <template v-if="!onlyView">
      <v-col class="pb-0 pt-0" cols="12" md="6">
        <el-date-picker
          :required="!isMistakeCorrection"
          pastDates
          label="Dokumento, patvirtinančio įgaliojimo pakeitimą, data"
          v-model="formData.change_confirm_date"
        />
      </v-col>
      <v-col class="pb-0 pt-0" cols="12" md="6">
        <el-autocomplete
          required
          :items="changeReasons"
          direct
          itemvalue="value"
          itemtext="text"
          label="Įgaliojimas pakeistas"
          v-model="formData.change_reason_id"
        />
      </v-col>
      <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="showEndNotarialNumber">
        <el-text-field
          :required="!formData.notarial_person_number && !isMistakeCorrection"
          label="Notarinio registro numeris"
          v-model="formData.change_notarial_no"
          :maxlength="20"
        />
      </v-col>
      <v-col class="pb-0 pt-0" cols="12" md="6" v-if="showEndNotarialPersonNumber">
        <el-text-field
          :required="!isMistakeCorrection"
          label="Asmens, turinčio teisę atlikti notarinius veiksmus, įgaliojimui suteiktas registracijos numeris"
          v-model="formData.notarial_person_number"
          :maxlength="20"
        />
      </v-col>
      <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
        <el-textarea
          :required="isMistakeCorrection"
          label="Pakeitimo aprašymas"
          v-model="formData.change_notes"
          :maxlength="2000"
        />
      </v-col>
    </template>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12" v-else>
      <el-simple-table :items="dataList" />
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'
import { classifiersGet } from '@/services/classifierService.js'
import Roles from '@/components/constants/roles'

export default {
  name: 'MandateChangeData',
  components: {},
  props: {
    formData: [Array, Object],
    onlyView: [Boolean],
  },
  data() {
    return {
      changeReasons: [],
    }
  },
  created() {
    this.getClassifiers()
  },
  computed: {
    isMistakeCorrection() {
      const er000 = this.changeReasons.find((item) => item.code === 'ER-000')
      if (er000) {
        return er000.value == this.formData.change_reason_id
      }
      return false
    },
    formatedTerms() {
      return Enums.terms
    },
    showEndNotarialNumber() {
      const userRole = this.$store.getters.userRole
      return [Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD, Roles.NOT_PAD2].some((item) => {
        return userRole.includes(item)
      });
    },
    showEndNotarialPersonNumber() {
      const userRole = this.$store.getters.userRole
      return [Roles.KAL_VAD].some((item) => {
        return userRole.includes(item)
      });
    },
    dataList() {
      return [
        {
          title: 'Dokumento, patvirtinančio įgaliojimo pakeitimą, data',
          value: this.formData.change_confirm_date,
        },
        {
          title: 'Įgaliojimas pakeistas',
          value: this.formData.change_reason_lt,
        },
        {
          title: 'Notarinio registro numeris',
          value: this.formData.change_notarial_no,
          hide: !this.formData.change_notarial_no,
        },
        {
          title: 'Asmens, turinčio teisę atlikti notarinius veiksmus, įgaliojimui suteiktas registracijos numeris',
          value: this.formData.notarial_person_number,
          hide: !this.formData.notarial_person_number,
        },
        {
          title: 'Pakeitimo aprašymas',
          value: this.formData.change_notes,
        },
      ]
    },
  },
  methods: {
    getClassifiers() {
      let search = [{key: 'basis-search-like', value: 'change'}]
      classifiersGet({ classifiers: ['expiration-reason'], search: search })
        .then(res => this.changeReasons = res.data.classifiers['expiration-reason'].lt)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
  },
}
</script>

<style>
</style>